<template>
  <div class="page-container">
    <el-card>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="ruleForm">
        <el-form-item label="账号类型" prop="accountType">
          <el-radio-group v-model="ruleForm.accountType">
            <el-radio label="department">科室</el-radio>
            <el-radio label="agent">代理商</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="省/市" prop="provinceCity" v-if="ruleForm.accountType === 'department'">
          <el-cascader :props="defaultProps" :options="options" v-model="ruleForm.provinceCity" @change="handleHospital"
                       clearable></el-cascader>
        </el-form-item>
        <el-form-item label="医院" prop="localId" v-if="ruleForm.accountType === 'department'">
          <el-select v-model="ruleForm.localId" placeholder="请选择医院">
            <el-option
              v-for="item in hospitalList"
              :key="item.localId"
              :label="item.name"
              :value="item.localId">
            </el-option>
          </el-select>
          <el-button type="primary" size="small" @click="handleHospitalAdd">添加医院</el-button>
        </el-form-item>
        <el-form-item label="姓名" prop="name" v-if="ruleForm.accountType === 'agent'">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender" v-if="ruleForm.accountType === 'agent'">
          <el-radio-group v-model="ruleForm.gender">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="科室" prop="departmentName" v-if="ruleForm.accountType === 'department'">
          <el-input v-model="ruleForm.departmentName"></el-input>
        </el-form-item>
        <el-form-item label="科室类型" prop="departmentType" v-if="ruleForm.accountType === 'department'">
          <el-select v-model="ruleForm.departmentType" placeholder="请选择">
            <el-option
              v-for="item in depTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-image v-if="ruleForm.departmentType" :src="department_icons[ruleForm.departmentType]" style="width: 32px;"/>
          <!--              <el-input v-if="pageType === 'edit'" v-model="ruleForm.departmentType"></el-input>-->
          <!--              <template v-else>{{ ruleForm.departmentType }}</template>-->
        </el-form-item>
        <el-form-item label="科室缩写" prop="orderAbbr" v-if="ruleForm.accountType === 'department'">
          <el-input v-model="ruleForm.orderAbbr"></el-input>
        </el-form-item>

        <el-form-item prop="agent" label="代理商">
          <el-select v-model="agentUserId" placeholder="请选择代理商">
            <el-option
              v-for="item in agentList"
              :key="item.userId"
              :label="item.agentName"
              :value="item.userId">
              <span style="float: left">{{ item.agentName }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.username }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="科室负责人姓名" prop="docName" v-if="ruleForm.accountType === 'department'">
          <el-input v-model="ruleForm.docName"></el-input>
        </el-form-item>
        <el-form-item label="代理商电话" prop="mobile" v-if="ruleForm.accountType === 'agent'">
          <el-input v-model.number="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="科室负责人电话" prop="mobile" v-else>
          <el-input v-model.number="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item label="短信通知" prop="notifyPhones" v-if="ruleForm.accountType === 'agent'">
          <el-tooltip content="多个手机号用逗号分隔" placement="right">
            <el-input v-model="ruleForm.notifyPhones" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>
        <el-form-item label="微信" prop="wechat" v-if="ruleForm.accountType === 'agent'">
          <el-input v-model="ruleForm.wechat"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input type="textarea" v-model="ruleForm.note"></el-input>
        </el-form-item>
        <el-form ref="payForm" :inline="true" :model="ruleForm" :style="{width: 1088+'px'}"
                 v-if="ruleForm.accountType === 'department'">
          <el-divider content-position="left" class="dep-divider">收费项目</el-divider>
          <div
            v-for="(payItem, index) in ruleForm.payItems"
            :key="payItem.key"
          >
            <el-form-item label="名称" label-width="100px" :prop="'payItems.' + index + '.name'"
                          :rules="{required: true, message: '名称不能为空', trigger: 'blur'}">
              <el-input v-model="payItem.name" :style="{width: 160+'px'}"></el-input>
            </el-form-item>
            <el-form-item label="终端价格" :prop="'payItems.' + index + '.price'"
                          :rules="{required: true, message: '金额不能为空', trigger: 'blur'}">
              <el-input-number v-model="payItem.price" :precision="2" :step="0.1" :min="0" :controls=false
                               :style="{width: 80+'px'}"></el-input-number>
            </el-form-item>
            <el-form-item label="代理商价格" :prop="'payItems.' + index + '.agentPrice'"
                          :rules="{required: false, message: '', trigger: 'blur'}">
              <el-input-number v-model="payItem.agentPrice" :precision="2" :step="0.1" :min="0" :controls=false
                               :style="{width: 80+'px'}"></el-input-number>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="payItem.desc" :style="{width: 200+'px'}"></el-input>
            </el-form-item>
            <el-button @click.prevent="removePayItem(payItem)" v-if="ruleForm.payItems.length > 1">移除</el-button>
            <el-divider class="dep-divider dep-inner-divider"></el-divider>
          </div>
          <el-form-item label=" " label-width="100px">
            <el-button icon="el-icon-plus" size="mini" type="primary" @click="addPayItem">添加收费项目</el-button>
          </el-form-item>
          <el-divider class="dep-divider"></el-divider>
        </el-form>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">添加</el-button>
          <el-button @click="handleCancle">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog
      title="添加医院"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="100px" class="addForm">
        <el-form-item label="省/市" prop="provinceCity">
          <el-cascader :props="defaultProps" :options="options" v-model="addForm.provinceCity" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="医院" prop="name">
          <el-input placeholder="请输入医院名称" v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="医院缩写" prop="abbr">
          <el-input placeholder="请输入医院缩写" v-model="addForm.abbr"></el-input>
        </el-form-item>
        <el-form-item label="logo" prop="logo">
          <el-upload
            class="avatar-uploader"
            action="/api/upload/image"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload">
            <img v-if="addForm.logo" :src="addForm.logo" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('addForm', true)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as R from 'ramda';
import {areas} from '@/utils/areas';
import {task as taskApi} from '@/api';
import {msToSecond} from '@/utils';
import departmentIcon0 from '@/assets/department/department_icon_0.png';
import departmentIcon1 from '@/assets/department/department_icon_1.png';
import departmentIcon2 from '@/assets/department/department_icon_2.png';
import departmentIcon3 from '@/assets/department/department_icon_3.png';
import departmentIcon4 from '@/assets/department/department_icon_4.png';
import departmentIcon5 from '@/assets/department/department_icon_5.png';
import departmentIcon6 from '@/assets/department/department_icon_6.png';
import departmentIcon7 from '@/assets/department/department_icon_7.png';
import departmentIcon9 from '@/assets/department/department_icon_9.png';

export default {
  name: 'AccountAdd',
  data() {
    const validateMobile = (rule, value, callback) => {
      if (String(value).length !== 11) {
        callback(new Error('请输入正确的电话号码！'));
        return;
      }
      callback();
    };
    return {
      dialogVisible: false,
      defaultProps: {
        value: 'code',
        label: 'name'
      },
      options: areas,

      addForm: {
        provinceCity: [],
        name: undefined,
        logo: undefined,
      },

      ruleForm: {
        accountType: 'department',
        gender: '1',
        name: undefined,
        departmentName: undefined,
        departmentType: 9,
        docName: undefined,
        localId: undefined,
        provinceCity: [],
        wechat: undefined,
        mobile: undefined,
        email: undefined,
        note: undefined,
        orderAbbr: undefined,
        payItems: [
          {
            key: 0,
            name: undefined,
            price: undefined,
            agentPrice: undefined,
            desc: undefined
          }
        ]
      },
      addRules: {
        name: [
          {required: true, message: '请输入医院名称', trigger: 'blur'},
        ],
        provinceCity: [
          {type: 'array', required: true, message: '请选择省市', trigger: 'change'},
        ],
        abbr: [
          {type: 'regexp', required: true, message: '请输入医院缩写', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let patt = /^[A-Z]{4}$/;
              if (!patt.test(value)) {
                callback(new Error('限定4个大写字母'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },
      rules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        departmentName: [
          {required: true, message: '请输入科室', trigger: 'blur'},
        ],
        accountType: [
          {required: true, message: '请选择账号类型', trigger: 'change'},
        ],
        gender: [
          {required: true, message: '请选择性别', trigger: 'change'},
        ],
        docName: [
          {required: true, message: '请输入医生姓名', trigger: 'blur'},
        ],
        orderAbbr: [
          {required: true, message: '请输入科室缩写', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let patt = /^[a-zA-Z]{2}$/;
              if (!patt.test(value)) {
                callback(new Error('限定2个字母'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        provinceCity: [
          {type: 'array', required: true, message: '请选择省市', trigger: 'change'},
        ],
        localId: [
          {required: true, message: '请选择医院', trigger: 'change'}
        ],
        mobile: [
          {required: true, message: '请选输入电话', trigger: 'blur'},
          {type: 'number', message: '电话必须为数字'},
          {validator: validateMobile, trigger: 'blur'}
        ],
        wechat: [
          {message: '请选输入微信号', trigger: 'blur'}
        ],
        email: [
          {message: '请输入电子邮件', trigger: 'blur'}
        ],
        note: [
          {message: '请输入备注', trigger: 'blur'}
        ],
      },

      provinceCity: [],

      hospitalList: [],

      visible: true,

      departmentAllFilter: [],
      departmentAllTable: [],
      depTypeList: [
        {id: 0, name: '肝胆外科'},
        {id: 1, name: '胸外科'},
        {id: 2, name: '泌尿外科'},
        {id: 3, name: '妇科'},
        {id: 4, name: '耳鼻喉科'},
        {id: 5, name: '头颈外科'},
        {id: 6, name: '胃肠外科'},
        {id: 7, name: '颅脑科'},
        {id: 9, name: '默认'},
      ],

      form: {},

      pageSize: 15,
      pageCount: 0,
      pageNo: 1,
      pageTotal: 0,

      tableData: [],
      payFormValid: false,

      agentList: [],
      localId: '',
      agentUserId: '',

      department_icons: [
        departmentIcon0,
        departmentIcon1,
        departmentIcon2,
        departmentIcon3,
        departmentIcon4,
        departmentIcon5,
        departmentIcon6,
        departmentIcon7,
        null,
        departmentIcon9,
      ]
    };
  },
  computed: {
    operates: ({$route}) => $route.meta.operates,
  },
  methods: {
    addPayItem() {
      this.ruleForm.payItems.push({
        name: undefined,
        price: undefined,
        agentPrice: undefined,
        desc: undefined,
        key: Date.now()
      });
    },
    removePayItem(payItem) {
      let index = this.ruleForm.payItems.indexOf(payItem);
      if (index !== -1) {
        this.ruleForm.payItems.splice(index, 1);
      }
    },
    handleAvatarSuccess(res) {
      this.addForm.logo = res.data;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    async lazyLoad(node, resolve) {
      const {data} = await taskApi.areasList({
        code: node.value || ''
      });
      resolve(data.map(e => ({
        value: e.code,
        label: e.name,
        leaf: e.level >= 2
      })));
    },
    handleHospitalAdd() {
      this.dialogVisible = true;
      if (this.ruleForm.provinceCity.length) {
        this.addForm.provinceCity = this.ruleForm.provinceCity;
      }
    },
    handleHospital(value) {
      if (value) {
        this.provinceCity = value;
      }
      if (!value && !this.provinceCity.length) return;
      taskApi.hospitalListName({
        pageNo: 1,
        pageSize: 1000,
        provinceId: this.provinceCity[0],
        cityId: this.provinceCity[1]
      })
        .then(res => {
          if (res.code === 10000) {
            const {data} = res.data;
            this.hospitalList = data;
            if (value) this.ruleForm.localId = '';
          }
        });
    },
    getForm() {
      const {departmentAllFilter} = this.$route.meta;
      const form = {};
      R.forEach(({type, prop, start, end}) => {
        form[prop] = '';
      }, departmentAllFilter);
      this.form = form;
    },
    onOperateClick(row, item) {
      const {onClick} = item;
      if (onClick) {
        onClick(row, this);
      }
    },
    onReset() {
      this.getForm();
    },
    onCreated() {
      const {departmentAllFilter, departmentAllTable} = this.$route.meta;
      this.departmentAllFilter = departmentAllFilter;
      this.departmentAllTable = departmentAllTable;
      this.getForm();
      this.loadAgent();
      this.query();
    },
    onSearch() {
      this.query();
    },
    onPageChange(pageNo) {
      this.query(pageNo);
    },
    handleCancle() {
      this.resetForm('ruleForm');
      this.visible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async query(pageNo = 1) {
      const {fetchDataName} = this.$route.meta;
      this.pageNo = pageNo;
      const submitForm = {};
      R.forEachObjIndexed((value, key) => {
        if (!value) return;
        const filterItem = R.find(R.propEq('prop', key), this.departmentAllFilter) || {};
        if (/_/.test(key)) { // 是 datetimerange
          if (R.isEmpty(value)) return;
          const [startKey, endKey] = key.split('_');
          const [startValue, endValue] = value;
          submitForm[startKey] = msToSecond(startValue);
          submitForm[endKey] = msToSecond(endValue);
        } else {
          submitForm[key] = filterItem.dataType === 'number' ? Number(value) : String(value);
        }
      }, this.form);
      // console.log(this.form, submitForm);
      submitForm.pageNo = this.pageNo;
      submitForm.pageSize = this.pageSize;

      let isEmpty = true;
      const formKeys = R.keys(this.form);
      R.forEach((key) => {
        const value = this.form[key];
        if (
          (R.is(Array, value) && !R.isEmpty(value)) ||
          (R.is(String, value) && (value !== '')) ||
          (R.is(Number, value))
        ) {
          isEmpty = false;
        }
      }, formKeys);
      let rq;
      if (isEmpty) {
        rq = taskApi[fetchDataName];
      } else {
        rq = taskApi['fetchAll'];
        const {status} = this.$route.meta;
        if (!R.isNil(status)) {
          submitForm.status = status;
        }
      }
      const res = await rq(submitForm);
      if (res.code === 10000) {
        const {pageCount, data, count} = res;
        this.pageCount = pageCount;
        this.pageTotal = count;
        this.tableData = data;
      }
    },
    submitForm(formName) {
      formName === 'ruleForm' &&
      this.ruleForm.accountType === 'department' &&
      this.$refs['payForm'].validate(valid => {
        this.payFormValid = valid;
        return valid;
      });
      this.$refs[formName].validate((valid) => {
        if (formName === 'ruleForm' && this.ruleForm.accountType === 'department' && !this.payFormValid) {
          return false;
        }
        if (valid) {
          const params = {
            name: this.ruleForm.departmentName,
            type: this.ruleForm.departmentType,
            logo: this.ruleForm.logo,
            docName: this.ruleForm.docName,
            mobile: String(this.ruleForm.mobile),
            notifyPhones: this.ruleForm.notifyPhones,
            wechat: this.ruleForm.wechat,
            note: this.ruleForm.note,
            localId: this.ruleForm.localId,
            email: this.ruleForm.email,
            orderAbbr: this.ruleForm.orderAbbr,
            province: this.ruleForm.provinceCity[0],
            city: this.ruleForm.provinceCity[1],
            createUserId: this.agentUserId ? this.agentUserId : 0,
          };
          if (this.ruleForm.accountType !== 'department') {
            params.name = this.ruleForm.name;
            params.gender = this.ruleForm.gender;
          } else {
            params.item = this.ruleForm.payItems.map(item => {
              return {name: item.name, price: item.price, agentPrice: item.agentPrice, desc: item.desc};
            });
          }
          if (formName === 'addForm') {
            const hparams = {
              name: this.addForm.name,
              logo: this.addForm.logo,
              abbr: this.addForm.abbr,
              orderAbbr: String(+new Date()),
              province: this.addForm.provinceCity[0],
              city: this.addForm.provinceCity[1]
            };
            taskApi.hospitalAdd(hparams)
              .then(res => {
                if (res.code === 10000) {
                  this.$message.success('操作成功！');
                  this.dialogVisible = false;
                  if (this.ruleForm.provinceCity.length) {
                    this.ruleForm.localId = res.data;
                  }
                  this.resetForm('addForm');
                  this.handleHospital();
                }
              });
            return;
          }
          taskApi[this.ruleForm.accountType === 'department' ? 'departmentAdd' : 'agentAdd'](params)
            .then(res => {
              if (res.code === 10000) {
                this.$message.success('操作成功！');
                this.dialogVisible = false;
                if (this.ruleForm.accountType === 'department') {
                  this.$router.push({
                    path: '/account/department/manage'
                  });
                } else {
                  this.$router.push({
                    path: '/account/agent/manage'
                  });
                }
              }
            });
          this.payFormValid = false;
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 更换代理商
    async loadAgent() {
      const res = await taskApi.agentList({pageNo: 1, pageSize: 999});
      if (res.code === 10000) {
        this.agentList = res.data.data;
      } else {
        this.$message.error(res.msg);
      }
    },
  },
  created() {
    this.onCreated();
  },
  watch: {
    'ruleForm.provinceCity'() {

    },
    '$route'() {
      this.onCreated();
    },
  }
};
</script>
<style scoped>
.page-container {
  background-color: #212731;
}

.ruleForm {
  width: 500px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.dep-divider {
  background-color: #121820;
}

.dep-inner-divider {
  margin: 0px 0px 22px 60px;
  width: 1016px;
}

.dep-divider .el-divider__text {
  background-color: #222933;
  color: #eee;
}
</style>



// WEBPACK FOOTER //
// src/view/AccountAdd/index.vue